import React from 'react';
import LandingHeader from '../header/landingHeader';
import Global from '../../global';
import Head from '../head/head';
import { getAWSUrl } from '../api/core';
import './landing.css';
import { DarkModeStore } from "../store/darkModeStore";

const Landing = (props) => {

  const theme = DarkModeStore.useState((s) => s.themeMode);
    return (
        <div style={{minHeight:'500px'}}>
            <Head title={"SMOTT"} quote={"SMOTT"} description={"Watch Movies, TV Shows & Live News Online - Smott Preview App"} image={""}   icon={Global.WEBICON ? getAWSUrl() + Global.WEBICON : localStorage.getItem("icon_logo")? getAWSUrl() + localStorage.getItem("icon_logo"):""}></Head>
            <LandingHeader branding={theme===Global.DARK?Global.Header:Global.DarkHeader} {...props}></LandingHeader>
            <section className="main-bg iq-blog">
        <div className="conatiner header-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 mt-3  wow fadeInLeft animated animated">
              <img className="heading" src={getAWSUrl()+(theme===Global.DARK?Global.Header:Global.DarkHeader)} alt={"Logo"} style={{height:'60px'}} />
              <h2 className="additional mt-4" style={{ textTransform: 'uppercase'}}>Watch Movies, TV Shows & Live News Online - Smott Preview App</h2>
              <a className="btn btn-hover iq-button mt-4"  href={"/"+props.match.params.AppId+"/register"}> GET STARTED</a>
            </div>
            <div className="col-md-6 text-center mt-3 wow fadeInRight animated animated">
              <div className="position-relative">
                <div className="pic">
                  <img className="img-fluid" src="/images/home/05.png" alt="images" />
                </div>
              </div>
            </div>  
          </div>
        </div>
      </section>


      <section className="additionaly">
        <div className="text-center mt-3 wow fadeInUp  animated animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
          <h2>Unlimited movies, TV shows and more</h2>     
        </div>
      </section>


      <section className="main-bg iq-blog">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-6 text-center wow fadeInLeft  animated animated" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
              <div className="position-relative">
                <div className="pic">
                  <img className="img-fluid" src="/images/home/03.png" alt="images" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 mt-3 wow fadeInRight  animated animated" style={{visibility: 'visible', animationName: 'fadeInRight'}}>
              <div className="ml-5">
                <span className="heading">Watch everywhere.</span>
                <h5 className="title-text mt-3">Stream unlimited movies and TV shows on your phone, tablet, laptop, and TV.</h5>
              </div>
            </div>  
          </div>
        </div>
      </section>


      <section className="additionaly">
        <div className="text-center mt-3 wow fadeInUp  animated animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
          <h2>Stream thousands of films on demand,including pay-per-view movies</h2>     
        </div>
      </section>


      <section className='tv'>
        <div className="container header-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="text-center wow fadeInUp  animated animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <span className="heading">Enjoy on your TV</span>
                <h5 className="mb-0 mt-3 title-text">Watch on Android TVs, Roku, Tizen, Chromecast, Apple TV, Fire Tv and more.</h5>
              </div>
            </div>   
          </div>
          <div className="row">  
            <div className="col-md-12 text-center">
              <div className="position-relative  wow fadeInUp  animated animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <div className="pic">
                  <img className="img-fluid" src="/images/home/08.png" alt="images" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="py-0">
        <div className="section-img position-relative">
          <img src="/images/home/show-1.jpg" alt="Snow" className="img-fluid" style={{opacity: '0.6'}} />
          <div className="textimg text-center  wow fadeInUp  animated animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
            <h1 className="font-weight-bold text-white">READY TO WATCH</h1>
            <h5 className="mb-0 text-whit mt-4 title-text">Join Now to watch the latest movies, TV shows and award-winning  Originals</h5>
            <a className="btn btn-hover iq-button mt-4" href={"/"+props.match.params.AppId+"/register"}> JOIN NOW</a>
          </div>
        </div>
      </section>
         
        </div>
    );
};



export default Landing;